import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('solution'),
  ...new Mutations('solutions'),
  ...new Mutations('summary'),
  ...new Mutations('selectedUser'),
};
